import React from "react";
import { useNavigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
// import APIs
import NewBasketApi from "../../api/customer/basket/NewBasket";
import RemoveFromBasketApi from "../../api/customer/basket/RemoveFromBasket";
import CreateOrderApi from "../../api/customer/order/Create";
import AllApi from "../../api/customer/address/All";

//import UIs
import BasketItemCard from "../../ui/cards/BasketItem";

import { FromInt, numberSpace } from "../../helpers/NumberTools";

//import modal
import AddAddressModal from "../../ui/modals/AddAddress";

//icon
import AddIcon from "@mui/icons-material/Add";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneAndroidIcon from "@mui/icons-material/PhoneAndroid";
import PhoneIcon from "@mui/icons-material/Phone";
import ApprovalIcon from "@mui/icons-material/Approval";
import PersonIcon from "@mui/icons-material/Person";

// material Ui
import Button from "@mui/material/Button";
import Radio from "@mui/material/Radio";
import { pink } from "@mui/material/colors";

//import skeletons
import AddressCardSkeleton from "../../ui/skeletons/AddressCard";

import { ErrorNotify, SuccessNotify } from "../../ui/Toast";
import { setIsLoading, setMetaData } from "../../redux/reducers/page";
const ViewBasket = () => {
  const navigate = useNavigate();

  const [sending, setSending] = React.useState(false);
  const [completeBasket, setCompleteBasket] = React.useState(false);
  const [isLoaded, setIsLoaded] = React.useState(false);
  const [addModalOpen, setAddModalOpen] = React.useState(false);
  const [basket, setBasket] = React.useState([]);
  const [addresses, setAddresses] = React.useState([]);
  const [customerAddress, setCustomerAddress] = React.useState(null);

  // redux
  const dispatch = useDispatch();
  const { auth } = useSelector((state) => state.customerAuth);

  // find ViewBasket basket
  const findBasket = async () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    setIsLoaded(false);
    const basketResult = await NewBasketApi(auth.token);

    if (basketResult.status !== 200) {
      ErrorNotify(JSON.parse(basketResult.response).error);
      return;
    }
    setBasket(basketResult.data);
    const result = await AllApi(auth.token);

    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      return;
    }
    setAddresses(result.data);
    setIsLoaded(true);
  };
  const selectAddress = (event) => {
    setCustomerAddress(event.target.value);
  };
  const controlProps = (item) => ({
    checked: customerAddress === item,
    onChange: selectAddress,
    value: item,
    name: "color-radio-button-demo",
    inputProps: { "aria-label": item },
  });
  const deleteFromBasket = async (basketItem) => {
    setIsLoaded(true);
    await RemoveFromBasketApi(
      auth.token,
      basketItem.id,
      basketItem.draftId,
      basketItem.basketId
    );
    findBasket();
  };
  const createOrder = async () => {
    const address = addresses.find((item) => item.id === +customerAddress);
    setSending(true);
    if (!address) {
      ErrorNotify("  نشانی انتخاب نشده ");
      setSending(false);
      return;
    }
    const result = await CreateOrderApi(
      auth.token,
      basket.id,
      null,
      address.id,
      address.recipientsName,
      address.recipientsPhone,
      address.recipientsMobiles
    );
    if (result.status === 400) {
      ErrorNotify(" مقادیر به درستی وارد نشده است ");
      setSending(false);
      return;
    }
    if (result.status !== 200) {
      ErrorNotify(JSON.parse(result.response).error);
      setSending(false);
      return;
    }
    SuccessNotify("سفارش شما ثبت شد");
    setSending(false);
    navigate(`/order/${result.data.id}`);
    return;
  };
  React.useEffect(() => {
    dispatch(
      setMetaData({
        title: "میشرت : سبد خرید",
        description: "میشرت: سبد خرید",
      })
    );
    dispatch(setIsLoading(false));
    findBasket();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div className="col-12 col-md-10  col-lg-9 col-xl-8  justify-content-center">
      <div className="row justify-content-center p-3 p-md-1 mb-5 pb-5">
        {isLoaded ? (
          basket.BasketItems.length !== 0 ? (
            <>
              {basket.BasketItems.map((basketItem, index) => {
                return (
                  <BasketItemCard
                    deleteFromBasket={deleteFromBasket}
                    key={index}
                    basketItem={basketItem}
                  />
                );
              })}
              {!completeBasket ? (
                <div className="row mt-4 p-0">
                  <span
                    onClick={() => setCompleteBasket(true)}
                    className="btn btn-primary w-100 d-flex justify-content-between align-items-center"
                  >
                    تکمیل خرید
                    <span className="badge badge-warning position-relative sabad_card-totalprice">
                      {FromInt(numberSpace(`${basket.totalPrice}`))} تومان{" "}
                    </span>
                  </span>
                </div>
              ) : (
                <>
                  <div className="row mt-4 p-0 cards">
                    <div className="col-6 p-2 text-right">
                      <h4>نشانی تحویل سفارش</h4>
                    </div>
                    <div className="col-6 p-2 text-left">
                      <Button
                        variant="contained"
                        onClick={() => setAddModalOpen(true)}
                        color="success"
                        endIcon={<AddIcon />}
                      >
                        ثبت نشانی جدید
                      </Button>
                    </div>

                    {addresses.map((address, index) => {
                      return (
                        <div className="col-12 " key={index}>
                          <div className="row justify-content-center">
                            <div className="col-12  ">
                              <hr />{" "}
                            </div>
                          </div>
                          <div className="row ">
                            <div className="col-1 my-auto">
                              <Radio
                                {...controlProps(`${address.id}`)}
                                sx={{
                                  color: pink[800],
                                  "&.Mui-checked": {
                                    color: pink[600],
                                  },
                                }}
                              />
                            </div>
                            <div className="col-11 my-auto">
                              <div className="row">
                                <div className="col-12">
                                  <PersonIcon className="m-1" />{" "}
                                  {FromInt(`${address.recipientsName}`)}
                                </div>
                                <div className="col-12 ">
                                  <LocationOnIcon className="m-1" />{" "}
                                  {FromInt(
                                    `${address.Province.name} - ${address.City} - ${address.recipientsAddress}`
                                  )}
                                </div>
                                <div className="col-12 ">
                                  <ApprovalIcon className="m-1" />{" "}
                                  {FromInt(`${address.postalCode}`)}
                                </div>
                                <div className="col-12 ">
                                  <PhoneAndroidIcon className="m-1" />{" "}
                                  {FromInt(`${address.recipientsMobiles}`)}
                                </div>
                                <div className="col-12  ">
                                  <PhoneIcon className="m-1" />{" "}
                                  {FromInt(`${address.recipientsPhone}`)}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <AddAddressModal
                      openModal={addModalOpen}
                      setOpenModal={setAddModalOpen}
                      auth={auth}
                      setAddresses={setAddresses}
                    />
                  </div>
                  <div className="row mt-4 p-0">
                    {!sending ? (
                      <span
                        onClick={createOrder}
                        className="btn btn-primary w-100 d-flex justify-content-between align-items-center"
                      >
                        ثبت سفارش
                        <span className="badge badge-warning position-relative sabad_card-totalprice">
                          {FromInt(numberSpace(`${basket.totalPrice}`))} تومان{" "}
                        </span>
                      </span>
                    ) : (
                      <span
                        style={{ cursor: "wait" }}
                        className="btn btn-secondary w-100 d-flex justify-content-between align-items-center"
                      >
                        در حال ارسال
                        <span className="badge badge-warning position-relative sabad_card-totalprice">
                          {FromInt(numberSpace(`${basket.totalPrice}`))} تومان{" "}
                        </span>
                      </span>
                    )}
                  </div>
                </>
              )}
            </>
          ) : (
            <div className="col-12">
              <p>در حال حاضر سبد خریدی برای شما ثبت نشده</p>
            </div>
          )
        ) : (
          <AddressCardSkeleton />
        )}
      </div>
    </div>
  );
};

export default ViewBasket;
